@if (decisionNoteNameLv) {
    <nz-form-item>
        <nz-form-label nzFor="notes">{{ decisionNoteNameLv }}</nz-form-label>
        <nz-form-control>
            <textarea rows="4" maxlength="300" nz-input [(ngModel)]="decisionNotes"></textarea>
        </nz-form-control>
    </nz-form-item>

    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="cancel()">Atcelt</button>
        <button nz-button nzType="primary" (click)="submitAndReturn()">Turpināt</button>
    </div>
}
